/*
  Protool — same-day dispatch line on the compact collection cards (.ptc).

  Fills every [data-ptc-dispatch] line that snippets/globo.filter.product.liquid
  renders under "Availability: In Stock". Globo strips <script> from its card
  template and caches the output, so the time-of-day wording has to be done
  here rather than in Liquid.

  RULES ARE COPIED FROM snippets/pt-dispatch-countdown.liquid (product page).
  If the cut-off times or bank holidays change there, change them here too.
    - Cut-off 16:15 Monday–Thursday, 15:50 Friday (Europe/London time)
    - Working days exclude weekends and England & Wales bank holidays

  Wording:
    - Working day, before cut-off:  "Order by 4:15pm for same-day dispatch"
    - After cut-off / weekend / BH: "Order now for dispatch tomorrow"
                                    "Order now for dispatch on Monday"
  A cut-off TIME rather than a ticking countdown — twelve timers ticking
  down the page at once is noise.

  Loaded from layout/theme.liquid on collection and search templates only,
  and not at all when the theme setting "Hide dispatch countdown" is ticked
  (the lines then stay hidden and the card just says "In Stock").
*/
(function () {
  if (window.__ptCardDispatchBound) return;
  window.__ptCardDispatchBound = true;

  var CUTOFF_DEFAULT = { h: 16, m: 15 };  /* Monday–Thursday */
  var CUTOFF_FRIDAY  = { h: 15, m: 50 };  /* Friday */

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /* England & Wales bank holidays — keep in step with pt-dispatch-countdown.liquid */
  var BANK_HOLIDAYS = [
    '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31',
    '2027-08-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29',
    '2028-08-28', '2028-12-25', '2028-12-26'
  ];

  function cutoffFor(d) {
    return d.getDay() === 5 ? CUTOFF_FRIDAY : CUTOFF_DEFAULT;
  }

  function dateKey(d) {
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var dd = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  function isWorkingDay(d) {
    var g = d.getDay();
    return g >= 1 && g <= 5 && BANK_HOLIDAYS.indexOf(dateKey(d)) === -1;
  }

  function londonNow() {
    var s = new Date().toLocaleString('en-GB', {
      timeZone: 'Europe/London', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var m = s.match(/(\d{2})\/(\d{2})\/(\d{4}),?\s+(\d{2}):(\d{2}):(\d{2})/);
    if (!m) return new Date();
    return new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +m[6]);
  }

  function nextDispatchDay(from) {
    var d = new Date(from.getTime());
    d.setHours(12, 0, 0, 0);
    do { d.setDate(d.getDate() + 1); } while (!isWorkingDay(d));
    return d;
  }

  /* 16:15 -> "4:15pm", 15:50 -> "3:50pm", 16:00 -> "4pm" */
  function clock(c) {
    var h = c.h % 12 || 12;
    var mins = c.m ? ':' + ('0' + c.m).slice(-2) : '';
    return h + mins + (c.h < 12 ? 'am' : 'pm');
  }

  function message() {
    var now = londonNow();
    var c = cutoffFor(now);
    var cutoff = new Date(now.getTime());
    cutoff.setHours(c.h, c.m, 0, 0);

    if (isWorkingDay(now) && now < cutoff) {
      return 'Order by <b>' + clock(c) + '</b> for same-day dispatch';
    }

    var next = nextDispatchDay(now);
    var tomorrow = new Date(now.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    var when = next.toDateString() === tomorrow.toDateString()
      ? '<b>tomorrow</b>'
      : 'on <b>' + DAY_NAMES[next.getDay()] + '</b>';
    return 'Order now for dispatch ' + when;
  }

  function apply() {
    var lines = document.querySelectorAll('[data-ptc-dispatch]');
    if (!lines.length) return;
    var html = message();
    for (var i = 0; i < lines.length; i++) {
      var text = lines[i].querySelector('.ptc-dispatch-text');
      if (!text) continue;
      if (text.innerHTML !== html) text.innerHTML = html;
      lines[i].hidden = false;
    }
  }

  /* Globo renders the cards after page load and re-renders them on every
     filter / sort / page change, so watch for new cards. */
  var queued = false;
  function applySoon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 100);
  }

  function start() {
    apply();
    new MutationObserver(applySoon).observe(document.body, { childList: true, subtree: true });
    setInterval(apply, 60000); /* roll over at the cut-off without a reload */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
